import React, { useState, useCallback, PropsWithChildren } from 'react';
import { Box, ScrollView } from 'native-base';
import { F } from 'ts-toolbelt';
import {
    ApiEnvironmentsNames,
    ApiEnvironmentsList,
    useSpringBigStore,
    observer,
    defaultDevEnv,
} from '@springbig/shared';
import { Caption, H2, Hr } from '~/shared/Typography';
import Loading from '~/shared/Loading';
import DeviceInfo from './components/DeviceInfo';
import { ResetButton } from './components/ResetButton';
import { useAppNavigate } from '..';
import { Button, FullScreenBox, Section } from '~/shared/Theme';
import voca from 'voca';

type EnvListProps = PropsWithChildren<{
    changeEnv: F.Function
    apiEnv: ApiEnvironmentsNames | null
}>;

const EnvList = ({ apiEnv, changeEnv }: EnvListProps) => (

    <>
        <H2>Change Environment</H2>

        <Caption mb={4}>
            Select which environment you would like to switch to
        </Caption>

        <Box flexDirection={'row'} flexWrap={'wrap'}>

            { ApiEnvironmentsList.map((val) => (

                <Button
                    key={val}
                    onPress={() => changeEnv(val)}
                    mr={3}
                    mb={4}
                    bg={(
                        val === apiEnv
                            ? 'primary'
                            : 'gray'
                    )}
                    text={voca.titleCase(val?.toString())}
                />
            ))}
        </Box>
    </>

);

const SelectEnv = () => {

    const [isLoading, setLoading] = useState(false);
    const { navigate } = useAppNavigate();

    const {
        logout,
        switchApiEnv,
        member,
        phoneNumber,
        apiEnv = __DEV__ ? defaultDevEnv : 'production'
    } = useSpringBigStore();

    // const isQaApp = useMemo(() => /springbigqa/.test(getBundleId()), []);

    const changeEnv = (val: ApiEnvironmentsNames) => {

        if (val === apiEnv) {
            return;
        }

        observer.once('env-changed', () => {

            setLoading(false);
        });

        setLoading(true);

        setTimeout(() => {

            switchApiEnv!(val);
        }, 1000);
    };

    const goHome = useCallback(() => {

        // if (member && member.id) {
        //     navigate('merchant/list');
        //     return;
        // }

        navigate('');
    }, [member, navigate]);

    return (
        <FullScreenBox>
            <Section p={4} fullScreen>

                { isLoading && <Loading isLoading={isLoading}/> }

                <Box>

                    <H2>Quick Actions</H2>

                    <Box
                        alignItems={'center'}
                        flexDirection={'row'}
                        flexWrap={'wrap'}
                    >

                        <Button
                            key={1}
                            text='Go Home'
                            bg='yellow'
                            onPress={goHome}
                            mb='1'
                            mr='1'
                        />
                        { phoneNumber &&
                            <Button
                                key={2}
                                text='Logout'
                                bg='grayLight'
                                onPress={logout}
                                mb='1'
                                mr='1'
                            />
                        }
                    </Box>

                    <Hr />

                    <EnvList apiEnv={apiEnv as any} changeEnv={changeEnv} />

                    {/* { isQaApp && (<Hr />) }
                        { isQaApp && (<ChangeMerchant />) } */}

                    <Hr />

                    <H2>Application State</H2>

                    <ResetButton />

                    <Hr />

                    <DeviceInfo />
                </Box>
            </Section>
        </FullScreenBox>
    );
};

export default SelectEnv;
